/**
 * The two pure bits of adSlot.js: JSON:API answer -> ads, ads -> one ad.
 *
 * Split out so `node scripts/test-adslot.mjs` can run them; the rest of the
 * slot is Mithril and flarum imports that only exist in a browser bundle.
 */

/**
 * Flatten `/advertisements/active`. Zone names arrive as included resources,
 * the ads themselves only carry the zone id.
 */
export function adsFromResponse(res) {
  const zones = {};

  ((res && res.included) || []).forEach((r) => {
    if (r.type === 'ad-zones') zones[r.id] = r.attributes.name;
  });

  return ((res && res.data) || []).map((ad) => {
    const rel = ad.relationships && ad.relationships.zone && ad.relationships.zone.data;

    return { id: ad.id, zone: rel ? zones[rel.id] : undefined, ...ad.attributes };
  });
}

/**
 * One ad for a zone, or null. `random` is injectable so the test is not a
 * coin toss.
 */
export function pickForZone(ads, zone, random = Math.random) {
  // No name means no zone, never "the ads whose zone we could not resolve".
  if (!zone) return null;

  const zoned = ads.filter((ad) => ad.zone === zone);

  return zoned.length ? zoned[Math.floor(random() * zoned.length)] : null;
}
